import * as React from 'react';
import { SVGProps } from 'react';

const SvgPalliativeCare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill={props.fill}
      d="M31.972 33.983v4.743l-19.119.024-4.728-4.728 23.847-.039Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="m27.59 2.865-1.597 6.2-.348-.1h-.002a20.49 20.49 0 0 0-11.282 0l-.354.102-1.598-6.202.375-.106h.002a26.308 26.308 0 0 1 14.428 0h.002l.375.106Z"
    />
    <path fill="currentColor" d="M24.818 24.45h-2.384v7.15h2.384v-7.15Z" />
    <path fill="currentColor" d="M27.2 26.834h-7.149v2.383h7.15v-2.383Z" />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M14 8.5v2.829a6.267 6.267 0 0 0 1.758 4.36 5.927 5.927 0 0 0 4.24 1.811 5.927 5.927 0 0 0 4.242-1.81A6.266 6.266 0 0 0 26 11.33V8.5M9 34v-7.469c-.002-1.687.586-3.336 1.69-4.74 1.102-1.402 2.67-2.496 4.506-3.142 1.836-.646 3.804-.485 5.804-.485"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M31 34v-7.469c.002-1.687-.586-3.336-1.69-4.74-1.102-1.402-2.67-2.496-4.506-3.142-1.836-.646-3.687-.485-5.804-.485"
    />
  </svg>
);

export default SvgPalliativeCare;
